'use strict';

var $ = require('jquery');
var Masonry = require('masonry-layout');
var ItemFilterManager = require('../lib/ItemFilterManager.js');
var setupFilters = require('./setupFilters.js');
var addSocialShare = require('./addSocialShare.js');
var Modal = require('../lib/Modal.js');

function setupInspiration() {
	// ====================================================================
	// Masonry
	// ====================================================================
	var container = document.querySelector('.inspirationList');
	var msnry = new Masonry(container, {
		itemSelector: '.inspiration--match',
		transitionDuration: '1s',
		// Stops images being moved from upper left to their position at load.
		// We can't have that happen because if we do then all images will be
		// loaded instead of lazy loaded
		initLayout: false
	});
	var updateMsnry = function() {
		msnry.reloadItems();
		msnry.layout();
	};

	// ====================================================================
	// Filters
	// ====================================================================
	var $filtersArea = $('.inspirationFilters');
	if ($filtersArea.length) {
		var $filterOptions = $('select, input', $filtersArea);
		var $products = $('.inspiration');
		var config = {
			filterItemSelector: 	'.inspirationFilter__option',
			filtersOnClass: 		'inspirationFilterArea--hasSelected',
			selectedClass: 			'inspirationFilter__option--selected',
			noMatchesRemainClass: 	'inspirationFilter__option--noMatchesRemain',
			notMatchClass: 			'inspiration--noMatch',
			matchClass: 			'inspiration--match',
			updateDisplayedFilterValue: function(filterName, labels) {
				$('.inspirationFilter__currentValue--for_' + filterName).children('input').val(labels.join(', '));
			},
			onUpdate: updateMsnry
		};

		new ItemFilterManager($filtersArea, $filterOptions, $products, config);
	}

	// ====================================================================
	// Mobile Filters
	// ====================================================================
	setupFilters('inspirationFilters');

	// ====================================================================
	// Modal
	// ====================================================================
	var hrefById = function(id, includeSelector) {
		var element = document.getElementById(id);
		var href = element.getAttribute('href');
		if (includeSelector === undefined || includeSelector) {
			href += ' .inspirationGallery';
		}
		return href;
	};
	function addSocialShareToFeatures(){
		var socialItems = $('.inspirationGallery').find('[data-social="true"]');
		for (var i = 0, l = socialItems.length; i<l; i++){
			addSocialShare(
				socialItems[i], socialItems[i].dataset.image, socialItems[i].dataset.title
			);
		}
	}
	var modal = new Modal('mi', {
		href: function(currColorboxSettings) {
			var id = currColorboxSettings.get('id');
			return hrefById(id, true);
		},
		onComplete: function() {
			addSocialShareToFeatures();
			/* 2024-09-08: setupThumbnails(); */
			setupSlideGallery();
		},
		className: 'inspirationModal',
		width: '100%',
		height: '100%',
		onClosed: function(skipSaveNextClose) {
			if (skipSaveNextClose !== true) {
				window.history.back();
				return false; // Do not do default close code.
			}
		}
	});

	modal.hrefById = hrefById.bind(modal);

	modal.preopen = function(opts) {
		if (this.isOpen()) {
			// Already open so instead of opening change the contents of the box
			var href = this.hrefById(opts.id, false);

			$.ajax({
				url: href,
				dataType: 'html'
			}).done(function(data) {
				var viewer = $(data).find('.inspirationGallery');
				$('.inspirationGallery').replaceWith(viewer);
				addSocialShareToFeatures();

				/* 2024-09-08:  selectCurrentThumbnail(); */

				setupSlideGallery();
			});

			return false;
		}

		return opts;
	};

	$('body').on('click', '.inspirationLink', function(event) {
		// If the user is holding down a modifier key that opens a link in a new window/tab, we let the native browser behavior take place.
		if (!event.ctrlKey && !event.metaKey && !event.shiftKey) {
			event.preventDefault();
			modal.open({id: this.id}, true, true, this.href);
		}
	});
	$('.inspirationLink').hover(function() {
		addSocialShare(this.parentNode, this.getAttribute('data-large'), this.getAttribute('data-title'));
	}, function() {
		// Mouse leave
	});

	/* 2024-09-08: Removed this. If we want it back, we need to resolve issues with the URL in the browser changing so it breaks the back button.
	function setupThumbnails() {
		var $thumbnailsArea = $('.inspirationItems');
		var $inspirationGallery = $('.inspirationGallery');

		if (!$thumbnailsArea.length && $inspirationGallery.length) {
			// Create thumbnail area
			// require .inspirationGallery
			var $thumbnailsArea = $('<div class="inspirationPreview"></div>').appendTo($inspirationGallery.parent());
			var	$thumbnailsOuter = $('<div class="inspirationItems"><div class="inspirationItems__inner"/></div>').appendTo($thumbnailsArea);
			$('<h2 class="inspirationPreview__heading">View More Projects</h2>').prependTo($thumbnailsArea);
			var $thumbnails = $thumbnailsOuter.find('.inspirationItems__inner');

			// Add thumbnail imags to area
			$('.inspirationList .inspiration--match a[data-thumbnail]').each(function() {
				var $this = $(this);
				var href = $this.attr('href');
				var id = $this.attr('id');
				var thumbnailSrc = $this.attr('data-thumbnail');
				var title = $this.attr('data-title');

				var thumbnail = [];
				thumbnail.push('<a href="'+ href +'" id="'+ id +'" class="inspirationLink inspirationItem">');
				thumbnail.push('<img class="inspirationItem__image" src="' + thumbnailSrc + '" alt="' + title + '" />');
				thumbnail.push('</a>');
				$thumbnails.append(thumbnail.join(''));
			});

			// Select current
			selectCurrentThumbnail();
		}
	}
	*/
	/* 2024-09-08: 
	function selectCurrentThumbnail() {
		var $viewer = $('.inspirationGallery');
		if ($viewer.length !== 0) {
			// Select current inspiration
			var currentId = $viewer.attr('data-inspirationid');
			var activeClass = 'inspirationItem--active';

			// Add class to currently being viewed
			var $currentThumbnail = $('.inspirationItems [id]')
										.removeClass(activeClass)
										.filter('[id="' + currentId + '"]')
										.addClass(activeClass);

			// Scroll to thumbnail
			var $thumbnailsArea = $('.inspirationItems__inner');
			var scrollLeft = $currentThumbnail.get(0).offsetLeft - $thumbnailsArea.get(0).offsetLeft;
			var currentScrollLeft = $thumbnailsArea.scrollLeft();
			if (scrollLeft < currentScrollLeft || scrollLeft + $currentThumbnail.outerWidth() > currentScrollLeft + $thumbnailsArea.outerWidth()) {
				// Scroll so thumbnail is within view
				$thumbnailsArea.scrollLeft(scrollLeft);
			}
		}
	}
	*/

	// ====================================================================
	// Gallery
	// ====================================================================
	// live HTMLCollection
	var galleryThumbs = document.getElementsByClassName('viewerGallery__thumb');
	var removeOldMediaTimeoutID = undefined;

	function removeOldMedia() {
		var nodes = document.querySelectorAll('.viewerGallery__media.unloading');
		for (var i = 0; i < nodes.length; i++) {
			nodes[i].classList.remove('unloading');
		}
		removeOldMediaTimeoutID = undefined;
	}
	function dealWithVideoPlayback(element){
		var iframe = element.querySelector('iframe');
		if (iframe){
			console.log(iframe);
			if (element.classList.contains('unloading')){
				iframe.setAttribute('data-src', iframe.getAttribute('src'));
				iframe.removeAttribute('src');
			} else {
				iframe.setAttribute('src', iframe.getAttribute('data-src'));
				iframe.removeAttribute('data-src');
			}
		}
	}
	function handleSlideThumbClick(){
		if (this.className.includes('selected')){
			return;
		}

		for (var i = 0; i < galleryThumbs.length; i++) {
			galleryThumbs[i].classList.remove('selected');
		}
		this.classList.add('selected');

		var oldElement = document.querySelector('.viewerGallery__media.selected');
		oldElement.classList.replace('selected','unloading');
		dealWithVideoPlayback(oldElement);

		var newElement = document.getElementById(this.dataset.href);
		newElement.classList.add('selected');
		dealWithVideoPlayback(newElement);

		if (removeOldMediaTimeoutID !== undefined) {
			clearTimeout(removeOldMediaTimeoutID);
		}
		removeOldMediaTimeoutID = window.setTimeout(removeOldMedia, 750);
	}
	function handleControlClick() {
		var direction = this.dataset.direction;
		if (direction){
			var selectedThumb = document.querySelector('.viewerGallery__thumb.selected');

			var thumbToDispatch = direction === 'prev'
				? selectedThumb.previousElementSibling
				: selectedThumb.nextElementSibling;

			if (thumbToDispatch) {
				thumbToDispatch.dispatchEvent(new MouseEvent("click", {
					view: window,
					bubbles: true,
					cancelable: true,
				}));
			}
		}
	}
	function setupSlideGallery(){
		if (!galleryThumbs.length){
			return;
		}
		for (var i = 0; i < galleryThumbs.length; i++) {
			galleryThumbs[i].addEventListener('click', handleSlideThumbClick);
		}
		var controls = document.querySelectorAll('.viewerGallery__controls .control');
		for (var i = 0; i < controls.length; i++) {
			controls[i].addEventListener('click', handleControlClick);
		}
	}
}

module.exports = {
	init : function() {
		if (!$('.__inspirationListing').length){
			return;
		}

		setupInspiration();
	}
};
